import Container from 'components/ui/Container';
import PrimaryButton from 'components/ui/PrimaryButton';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  useCreateTraineeMarksMutation,
  useListTraineeEvaluationCriteriaQuery,
  useListTraineeMarkCriteriaQuery,
  useListTraineeQuery,
  useUpdateTraineeMarksMutation
} from 'redux/reducers/TraineeEvaluation';
import CustomButton from './CustomButton';
import { useUpdateMarks } from 'service/admin.query';

function isNumber(str: any) {
  if (str === '') {
    return false;
  }

  return !isNaN(str);
}

const ItemField = ({ item, item3, isHover, handleAllMarks }: any) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputMarks, setInputMarks] = useState<number | null>(null);
  const [loadingID, setLoadingID] = useState(0);
  const [changeButton, setChangebutton] = useState<any[]>([]);
  // const [editState, setEditState] = useState<boolean | null>(false);
  // const [fetchMarksAgain, setFetchMarksAgain] = useState<boolean | null>(false);
  const [updateTraineeMarks, { isLoading: isUpdating }] = useUpdateTraineeMarksMutation();
  const [createTraineeMarks, { isLoading: isCreating }] = useCreateTraineeMarksMutation();
  const { mutate: updateMarks, isLoading } = useUpdateMarks(loadingID)
  return (
    <div
      className="col-lg-4 col-md-6 col-sm-12"
      key={item.id}
      style={{ marginTop: "15px" }}
    >
      <div className="card shadow-sm border-0 h-100">
        <div className="card-body">

          <div className="mb-3">
            <small className="text-muted">Evaluator</small>
            <div className="fw-semibold">
              {item.evaluator_details.first_name + " " + item.evaluator_details.last_name}
            </div>
          </div>

          <div className="mb-2">
            <h6 className="mb-2">
              {item3.evaluation_criteria_details?.name}
            </h6>
          </div>

          <div className="d-flex gap-2 align-items-start">
            <input
              required
              className="form-control"
              type="number"
              ref={inputRef}
              min={1}
              max={80}
              defaultValue={item.assign_marks}
              placeholder={
                item3?.assign_marks?.length === 0 || item3?.assign_marks === null
                  ? `0/${item3.max_marks}`
                  : `${item3?.assign_marks?.[0]?.obtain_marks}/${item3.max_marks}`
              }
              onChange={(event) => {
                const num = isNumber(event.target.value)
                let val = Number(event.target.value);
                const maxVal = 80;
                if (val > maxVal) {
                  return toast.warn('Cannot enter greater than max mark')
                }


                if (num) {
                  setInputMarks(event.target.value as any);
                }
              }}
            />

            {item.assign_marks ? (
              <CustomButton
                isDanger={true}
                title={
                  (loadingID === item.id && isLoading) ? (
                    <div className="spinner-border spinner-border-sm" />
                  ) : (
                    "Edit"
                  )
                }
                onClick={() => {
                  if (Number(inputMarks) > 80) return toast.warn('Cannot enter greater than max mark')
                  setLoadingID(item.id);
                  updateTraineeMarks({
                    newId: item.evaluation_mark_id,
                    obtain_marks: inputMarks
                  })
                    .unwrap()
                    .then((err: any) => {
                      toast.success("Marks edited successfully");
                      handleAllMarks(inputMarks);
                      (inputRef.current as HTMLInputElement).value = "";
                    })
                    .finally((err: any) => {
                      setLoadingID(0)
                    });
                  // const payload = {
                  //   newId: item.evaluation_mark_id,
                  //   obtain_marks: inputMarks
                  // }
                  // updateMarks(payload,{
                  
                  // })
                }}
                type="button"
              />
            ) : (
              <CustomButton
                title={
                  loadingID === item.id ? (
                    <div className="spinner-border spinner-border-sm mx-2" />
                  ) : (
                    "Submit"
                  )
                }
                onClick={() => {
                  if (Number(inputMarks) > 80) return toast.warn('Cannot enter greater than max mark')

                  setLoadingID(item.id);
                  createTraineeMarks({
                    routine_evaluator: item?.id,
                    trainee: isHover,
                    obtain_marks: inputMarks
                  })
                    .unwrap()
                    .then((err: any) => {

                      handleAllMarks(inputMarks);
                      (inputRef.current as HTMLInputElement).value = "";
                      toast.success("Marks assigned successfully");
                    })
                    .finally(() => setLoadingID(0));
                }}
                type="button"
              />
            )}
          </div>

          <div className="mt-2">
            <small className="text-muted">
              Max Marks: {item3.max_marks}
            </small>
          </div>

        </div>
      </div>
    </div>
  );
};

const TraineeEvaluation = () => {
  const [editStatee, setEditStatee] = useState<any>(null);
  const [fetchMarksAgainn, setFetchMarksAgainn] = useState<any>(null);

  const { id } = useParams();
  const { data: TraineeList, isLoading: TraineeLoading } = useListTraineeQuery(id);
  const [alldata, setAllData] = useState([]);
  const [filtereddata, setFilteredData] = useState(alldata);
  const valueRef = useRef();
  const [isHover, setIsHover] = useState();
  const navigate = useNavigate();
  const { data: EvaluationQueryData, isLoading: EvaluationListLoading } =
    useListTraineeEvaluationCriteriaQuery({ id, isHover, fetchMarksAgainn });
  // useListTraineeEvaluationCriteriaQuery({ id, isHover });

  const { data: TraineeData, isLoading: TraineeMarkLoading } = useListTraineeMarkCriteriaQuery({
    id,
    isHover,
    editStatee
  });
  const TraineeMarkData = TraineeData?.data ?? [];
  // const [loadingID, setLoadingID] = useState(null);
  const filteredArr = EvaluationQueryData?.data?.reduce((acc: any, current: any) => {
    const x = acc.find(
      (item: any) =>
        item.evaluation_criteria_details.evaluation_criteria_detail.name ===
        current.evaluation_criteria_details.evaluation_criteria_detail.name
    );
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []);

  useEffect(() => {
    if (!filtereddata || !filtereddata?.length) return;
    const id = (filtereddata?.[0] as { id: any })?.id;
    valueRef.current = id;
  }, [filtereddata]);

  const handleSearch = (event: any) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    result = alldata.filter((data: any) => {
      return data.first_name.toLowerCase().search(value) != -1;
    });

    setFilteredData(result);
  };

  const Result = {
    routine_evaluator: '',
    trainee: '',
    obtain_marks: ''
  };
  // const handleFetchMarks = () => {
  //   // console.log('boolean', fetchMarks);
  //   setFetchMarksAgainn((prev) => !prev);
  // };

  const handleAllMarks = (newMark: any) => {
    setEditStatee(newMark);
    setFetchMarksAgainn(newMark);
  };
  useEffect(() => {
    setAllData(TraineeList?.data);
    setFilteredData(TraineeList?.data);
    setIsHover(TraineeList?.data?.[0]?.id);
  }, [TraineeList]);
  const [selectedId, setSelectedId] = useState<number>(0)
  return (
    <Container title="Trainee Evaluation"

      btn1Clicked={() => {
               navigate(
          `/routine-management/trainee-evaluation/${id}/generate-certificate/${isHover}`
        );

      }}
      btnTitle='View Report'
      btn1Title='Generate Certificate'
      OnBackClicked={() => {
 
        navigate(`/routine-management/${id}/View_Report`);

      }}

    >
      <div>
        <div className="row">
          <div className="col-lg-3 col-md-4 border-end d-flex flex-column bg-white p-0" style={{ height: '80vh' }}>

            {/* Sticky Search Header */}
            <div className="p-3 border-bottom bg-light">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control ps-5 rounded-pill border-0 shadow-sm"
                  placeholder="Search trainee..."
                  style={{ backgroundColor: '#fff' }}
                  onChange={(event) => handleSearch(event)}
                />
                <i className="ri-search-line position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
              </div>
            </div>

            {/* Scrollable List Area */}
            <div className="flex-grow-1 overflow-auto custom-scrollbar">
              {TraineeLoading ? (
                <div className="d-flex flex-column align-items-center justify-content-center h-100 py-5">
                  <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                  <span className="mt-2 text-muted small">Loading trainees...</span>
                </div>
              ) : filtereddata?.length > 0 ? (
                filtereddata.map((item: any) => {
                  const isActive = item.id === selectedId; // Renamed from isHover
                  return (
                    <div
                      key={item.id}
                      onClick={() => {
                        setIsHover(item?.id)
                        setSelectedId(item.id)
                      }}
                      className={`d-flex align-items-center p-3 border-bottom cursor-pointer transition-all ${isActive ? 'bg-primary-subtle border-start border-primary border-4' : 'bg-white hover-bg-light'
                        }`}
                      style={{
                        cursor: 'pointer',
                        transition: '0.2s ease-in-out',
                        borderLeft: isActive ? '4px solid #0d6efd' : '4px solid transparent'
                      }}
                    >
                      {/* Avatar Circle */}
                      <div className={`rounded-circle d-flex align-items-center justify-content-center me-3 ${isActive ? 'bg-primary text-white' : 'bg-secondary-subtle text-secondary'}`}
                        style={{ width: '40px', height: '40px', minWidth: '40px', fontWeight: '600' }}>
                        {item.first_name[0]}{item.last_name[0]}
                      </div>

                      {/* Name Info */}
                      <div className="overflow-hidden">
                        <h6 className={`mb-0 text-truncate ${isActive ? 'text-primary fw-bold' : 'text-dark'}`}>
                          {item.first_name} {item.last_name}
                        </h6>
                        <small className="text-muted">Trainee ID: #{item.id.toString().slice(-4)}</small>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center p-4 text-muted small">No trainees found</div>
              )}
            </div>
          </div>

          <div className="col ">
            {/* <div className="row">
              <div className="col-12 d-flex justify-content-end">
                <div>
                  <PrimaryButton
                    type="button"
                    title="View Report"
                    onClick={() => {
                      navigate(`/routine-management/${id}/View_Report`);
                    }}
                  />
                </div>
                <div style={{ marginLeft: '15px' }}>
                  <PrimaryButton
                    type="button"
                    title="Generate Certificate"
                    onClick={() => {
                      navigate(
                        `/routine-management/trainee-evaluation/${id}/generate-certificate/${isHover}`
                      );
                    }}
                  />
                </div>
              </div>
            </div> */}
            <div className="row g-3">
              {[
                { label: "Total Marks", value: TraineeMarkData?.total_marks, color: "text-secondary" },
                { label: "Obtained Marks", value: TraineeMarkData?.obtain_marks, color: "text-primary" },
                { label: "Division", value: TraineeMarkData?.division, color: "text-info" },
                { label: "Percentage", value: `${TraineeMarkData?.percentage?.toFixed(2) || 0}%`, color: "text-success" }
              ].map((stat, idx) => (
                <div key={idx} className="col-md-3">
                  <div className="p-3 border rounded shadow-sm bg-light text-center">
                    <div className="text-uppercase fw-bold text-muted small mb-1">{stat.label}</div>
                    <div className={`h5 mb-0 fw-bold ${stat.color}`}>{stat.value}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="card-body p-0">


              <div className="evaluation-container ">
                {EvaluationListLoading ? (
                  <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  filteredArr?.map((item: any) => (
                    <div className="card mb-4 border-0 shadow-sm" key={item.id}>
                      {/* Header Section */}
                      <div className="card-header bg-white border-bottom-0 pt-3">
                        <h5 className="fw-bold text-dark mb-0">
                          {item.evaluation_criteria_details?.evaluation_criteria_detail?.name}
                        </h5>
                      </div>

                      <div className="card-body">
                        {EvaluationQueryData?.data?.map((item3: any) =>
                          item.evaluation_criteria_details?.evaluation_criteria_detail?.name ===
                            item3.evaluation_criteria_details?.evaluation_criteria_detail?.name
                            ? item3.routine_evaluation.map((item2: any) => {


                              return (

                                <div key={item2.id} className="mb-3 p-3 border rounded-3 bg-light bg-opacity-50">
                                  <ItemField
                                    item={item2}
                                    item3={item3}
                                    isHover={isHover}
                                    handleAllMarks={handleAllMarks}
                                  />
                                  {/* <div className="d-flex flex-wrap justify-content-between align-items-center">
                                    <div>
                                      <div className="text-muted small text-uppercase fw-semibold">Evaluator</div>
                                      <div className="fw-bold text-secondary">
                                        {`${item2?.evaluator_details?.first_name} ${item2?.evaluator_details?.last_name}`}
                                      </div>
                                      <div className="mt-1">
                                        <span className="text-primary fw-medium">
                                          {item3.evaluation_criteria_details?.name}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="mt-2 mt-md-0">
                                      <span className="badge rounded-pill bg-success-subtle text-success border border-success px-3 py-2">
                                        <i className="bi bi-check-circle-fill me-1"></i>
                                        Already Assigned Mark
                                      </span>
                                    </div>
                                  </div> */}
                                </div>
                              )
                            }
                            )
                            : null
                        )}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>

        <hr />
      </div>
    </Container>
  );
};

export default TraineeEvaluation;
